import { render, staticRenderFns } from "./AIChatbotIframeError.vue?vue&type=template&id=b92a3d22&scoped=true"
import script from "./AIChatbotIframeError.vue?vue&type=script&lang=js"
export * from "./AIChatbotIframeError.vue?vue&type=script&lang=js"
import style0 from "./AIChatbotIframeError.vue?vue&type=style&index=0&id=b92a3d22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b92a3d22",
  null
  
)

export default component.exports